module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAWBJREFUSEvt1L9Lw1AQwPHvpRUsOPs3CDrUdtGUFlzdXERXF0EouFlSCx2MdXMQHZzcdHRwF4xtRfwxKP4DOjkWlBabPClSJTV5ra2DgxnD3efe3Tue0MtnleOIOgEa4C1iZy67pUm3ANbOxxni3hfnRZJsTt/ocvWwVU1guNeBgDJS2GYlDA+Hc06SqFxpO9LgwbBVnsBQd13H1AoIwb/DhYskqqk/aWfFANwP99J+WBsd+Besu6ieZgK4YlJKVVvhH3DQSvWKdcY1jQRb5q2Qq0wS9bQ7+eMabmRKyDuviMR+nKzfw7pQPB3mmeivwqM0/VuxXs6CZ/ZVRBkOdmqvndsBO4cgC33BqGM20nP/cOvRGGAUiizII6giQtx/F4PAT28xDmbq5M9WEWP7D8B5ZxeRldB1051YqX3s9HLwurUeoyhHwEggXquNsTPbwHKWECl8xggvuN48pcxD+987yjiSCxQMOJ8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home2.png
// module id = EPhj
// module chunks = 20